const tr = {
  reportsCielo: {
    attributes: {
      user_id: 'ID Titular',
      card_name: 'Dono do cartão',
      person_name: 'Titular',
      payment_id: 'ID Pagamento',
      cc_number: 'Número do Cartão',
      cpf: 'CPF',
      value: 'Valor (R$)',
      payment_type: 'Tipo',
      status_message: 'Status',
      installments: 'Parcelas',
      reports: 'Relatório Cielo/Braspag',
      reports_description:
        'Relatório de vendas realizadas através das integrações com Cielo e com Braspag',
      created_at: 'Criado em',
      approved_at: 'Aprovada em',
      tid: 'TID',
      product: 'Tipo do produto',
      productName: 'Produto',
      holder: 'Titular',
      InstallmentsValue: 'Valor da Parcela',
      NumberOfLives: 'Numero de vidas',
      protectCard: 'Cartão Protegido',
      recurrence: 'Recorrência',
      transactionError: 'Erro na compra',
      error_code: 'Codigo',
      error_message: 'Mensagem',
      is_renewal: 'Status renovado',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      notUsedDaysAfter: 'Não utilizado dentro de 7 dias',
      notRenewedAfterAcquire: 'Não renovados pós-compra',
      onlyRenewed: 'Somente renovados',
    },
    defSingular: 'Relatório Cielo/Braspag',
  },
};

export default tr;
